import isNotEmptyString from '../../../lib/helper-functions/isNotEmptyString';

/**
 * True when a platform signs in through OAuth but its sign-in cannot be
 * started right now.
 *
 * central-api's MCP index marks an OAuth platform with `configs.oauth`
 * (`{ provider, scopes }`) and sends the consent URL as `oauth_url`. That URL
 * comes back empty when the environment has no OAuth app configured for the
 * provider (Pinterest and Microsoft Ads return '' on purpose). Such a platform
 * has no working credential form either: its fields only name the account,
 * the access itself comes from the OAuth token, so saving them can only fail.
 * API-key and keyless platforms never carry `configs.oauth`, so they are not
 * affected.
 */
export function isOauthConnectUnavailable(mcp: any): boolean {
  const oauthConfig = mcp?.configs?.oauth;
  const isOauthPlatform =
    !!oauthConfig &&
    typeof oauthConfig === 'object' &&
    !Array.isArray(oauthConfig);

  return isOauthPlatform && !isNotEmptyString(mcp?.oauth_url);
}
